var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    loadProductFirst: !1,
    showPlaceholderProductList: !0,
    placeholderProductPerRow: 4,
    placeholderProductGridItemClass: 'PLACEHOLDER',
  },
};

// Helper function to get image configuration
const getImageConfig = (type) => {
  const config = boostPFSThemeConfig?.imageConfig?.[type];
  if (!config) {
    // Fallback to defaults if config is missing
    return type === 'productCards'
      ? { widths: [180, 360, 540, 600], sizes: "(min-width: 1280px) 25vw, (min-width: 768px) 33vw, 50vw" }
      : { widths: [360, 540, 720, 900, 1080], sizes: "(min-width: 768px) 50vw, 100vw" };
  }
  return config;
};

!(function () {
  let productCardCounter = 0;
  function t({ elContainer: t, blocks: e, limit: i }) {
    (c = 1),
      productCardCounter = 0,
      t.insertAdjacentHTML(
        'beforeend',
        e.slice(0, i).reduce(
          (t, e) => (
            (t += (function (t) {
              const { type: e } = t;
              const isProductCard = Boolean(t.product);
              const isFeaturedBlock = Boolean(e);
              if (isProductCard) productCardCounter++;

              let i = isProductCard
                  ? boostPFSTemplate.productGridItemHtml
                  : isFeaturedBlock
                    ? boostPFSTemplate.mediaGridItemHtml
                    : boostPFSTemplate.textGridItemHtml,
                a = '--col-span: 1; --row-span: 1;';
              if (
                (isFeaturedBlock && (a = `--col-span: 2; --row-span: ${'2x1' === e ? 1 : 2};`),
                (i = i.replace(
                  /{{extraClass}}/g,
                  'c-collection__item--' + (isFeaturedBlock ? 'featured' : 'text')
                )),
                (i = i.replace(/{{itemAttribute}}/g, `--i: ${c};${a}`)),
                (i = i.replace(
                  /{{itemAspectRatio}}/g,
                  '2x2' == e ? 'product' : e ? 'product-alt' : ''
                )),
                i.includes('{{itemImages}}'))
              ) {
                const { mediaFallback: e, image: a, video_url: o } = t,
                  s = t.product?.media || [];
                let r = '';
                const shouldEagerLoad = isProductCard ? (productCardCounter <= 4) : (c === 1);
                switch (!0) {
                  case Boolean(o): {
                    const t = o.includes('vimeo') ? 'vimeo' : 'youtube';
                    r = `\n                    <div class="c-video  js-video" data-autoplay="true" data-fit="cover" data-id="${
                      'vimeo' === t
                        ? (function (t) {
                            const e = t.match(
                              /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/
                            );
                            return e ? e[3] : void 0;
                          })(o)
                        : (function (t) {
                            const e = t
                              .replace(/(>|<)/gi, '')
                              .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
                            return e[2] && e[2].split(/[^0-9a-z_\-]/i)[0];
                          })(o)
                    }" data-type="${t}" data-status="paused">\n                        <div class="c-video__container  js-video-container" data-url="${o}"></div>\n                    </div>`;
                    break;
                  }
                  case Boolean(a):
                    const aConfig = getImageConfig('featuredBlocks');
                    const aBaseUrl = a.split('?')[0];
                    const aSrcset = aConfig.widths.map(w => `${aBaseUrl}?width=${w} ${w}w`).join(', ');
                    const aLoading = shouldEagerLoad ? 'eager' : 'lazy';
                    r += `<img class="o-img  o-img--cover  o-ar__item  u-product-bg" src="${aBaseUrl}?width=720" srcset="${aSrcset}" sizes="${aConfig.sizes}" loading="${aLoading}" alt="">`;
                    break;
                  case Boolean(e):
                    'video' === e.media_type
                      ? (r = `\n                        <div class="c-video  js-video" data-autoplay="true" data-fit="cover" data-id="${e.id}" data-type="HTML5" data-status="paused">\n                            <div class="c-video__container  js-video-container" data-sources-accentuate=${JSON.stringify(e)} ></div>\n                        </div>\n                        `)
                      : (() => {
                          const eConfig = getImageConfig('featuredBlocks');
                          const eBaseUrl = e.src.split('?')[0];
                          const eSrcset = eConfig.widths.map(w => `${eBaseUrl}?width=${w} ${w}w`).join(', ');
                          const eHeight = Math.round(720 / e.aspect_ratio);
                          const eLoading = shouldEagerLoad ? 'eager' : 'lazy';
                          r += `<img class="o-img  o-img--cover  o-ar__item  u-product-bg" src="${eBaseUrl}?width=720" srcset="${eSrcset}" sizes="${eConfig.sizes}" width="720" height="${eHeight}" loading="${eLoading}" alt="{{itemTitle}}">`;
                        })();
                    break;
                  case s?.length > 0:
                    const sConfig = getImageConfig('featuredBlocks');
                    const sLoading = shouldEagerLoad ? 'eager' : 'lazy';
                    r = s.slice(0, 2).reduce((t, e) => {
                      const i = e.width / e.height;
                      const widths = sConfig.widths.filter((w) => w <= e.width);
                      const baseUrl = e.src.split('?')[0];
                      const srcsetUrls = widths.map(w => `${baseUrl}?width=${w} ${w}w`).join(', ');
                      const fallbackSrc = `${baseUrl}?width=720`;
                      const imgHeight = Math.round(720 / i);

                      return (
                        t +
                        `<img class="o-img  o-img--cover  o-ar__item  u-product-bg" src="${fallbackSrc}" srcset="${srcsetUrls}" sizes="${sConfig.sizes}" width="720" height="${imgHeight}" loading="${sLoading}" alt="{{itemTitle}}">`
                      );
                    }, '');
                    break;
                  default:
                    const noImgConfig = getImageConfig('featuredBlocks');
                    const noImgUrl = Settings.getSettingValue('general.no_image_url');
                    const noImgBaseUrl = noImgUrl.split('?')[0];
                    const noImgSrcset = noImgConfig.widths.map(w => `${noImgBaseUrl}?width=${w} ${w}w`).join(', ');
                    const noImgLoading = shouldEagerLoad ? 'eager' : 'lazy';
                    r = `<img class="o-img  o-img--cover  o-ar__item  u-product-bg" src="${noImgBaseUrl}?width=720" srcset="${noImgSrcset}" sizes="${noImgConfig.sizes}" loading="${noImgLoading}" alt="">`;
                }
                i = i.replace(/{{itemImages}}/g, r);
              }
              if (
                (i.includes('{{itemUrl}}') &&
                  (i = i.replace(
                    /{{itemUrl}}/g,
                    t.product ? Utils.buildProductItemUrl(t.product) : (t.link ?? '#')
                  )),
                i.includes('{{itemText}}') && (i = i.replace(/{{itemText}}/g, t.text)),
                i.includes('{{itemStyles}}') &&
                  (i = i.replace(
                    /{{itemStyles}}/g,
                    `--font-size: ${t.font_size_desktop}px; --font-size-mob: ${t.font_size_mobile}px; letter-spacing: ${t.font_spacing}px; font-family: '${t.font_family}'; color: ${t.font_color};`
                  )),
                t.product)
              ) {
                const e = [...new Set(t.product.variants.map(({ price: t }) => t / 100))],
                  a = Globals.moneyFormat.replace('amount', 'amount_no_decimals');
                i = i.replace(
                  /{{itemPrices}}/g,
                  e.map((t) => Utils.formatMoney(t, a)).join('<span>|</span> ')
                );
                const o = t.product.tags.find((t) => t.startsWith('badge-'))?.replace('badge-', '');
                i = i.replace(/{{itemBadge}}/g, p(o || ''));
                let s = '',
                  r = 'Quick Shop';
                !t.product.available &&
                  ((s = 'disabled'),
                  (r = t.product.tags.find((t) => t.startsWith('coming-soon'))
                    ? 'Coming Soon'
                    : 'Sold Out')),
                  (i = i.replace(/{{quickBuyText}}/g, r)),
                  (i = i.replace(/{{quickBuyAttributes}}/g, s)),
                  (i = i.replace(/{{itemId}}/g, t.product.id)),
                  (i = i.replace(/{{itemTitle}}/g, t.product.title)),
                  (i = i.replace(/{{itemHandle}}/g, t.product.handle)),
                  (i = i.replace(/{{itemIntensity}}/g, ''));
              }
              return (c += 1), i;
            })(e)),
            t
          ),
          ''
        )
      );
  }
  BoostPFS.inject(this),
    window.location.search.includes('sort') || (Globals.queryParams.sort = ''),
    jQ('.search__results-count').addClass('boost-pfs-search-total-result'),
    (ProductGridItem.prototype.compileTemplate = function (t) {
      t || (t = this.data);
      productCardCounter++;
      const shouldEagerLoad = productCardCounter <= 4;
      const productConfig = getImageConfig('productCards');
      const e = t.images_info || t.product.media;
      let i = !t.available,
        a = boostPFSTemplate.productGridItemHtml,
        o = [e[0]].reduce((t, e) => {
          const i = e.width / e.height;
          const widths = productConfig.widths.filter((w) => w <= e.width);
          const baseUrl = e.src.split('?')[0];
          const srcsetUrls = widths.map(w => `${baseUrl}?width=${w} ${w}w`).join(', ');
          const fallbackSrc = `${baseUrl}?width=360`;

          return (
            t +
            `<img class="o-img  o-img--contain o-ar__item  u-product-bg" src="${fallbackSrc}" srcset="${srcsetUrls}" sizes="${productConfig.sizes}" width="${widths[widths.length - 1]}" height="${Math.round(widths[widths.length - 1] / i)}" loading="${shouldEagerLoad ? 'eager' : 'lazy'}" alt="{{itemTitle}}">`
          );
        }, '');
      const s = t.metafields.find((t) => 'hover_image' === t.key);
      if (s) {
        const [hoverImg] = JSON.parse(s.value);
        if (hoverImg?.src) {
          const baseUrl = hoverImg.src.split('?')[0];
          const srcsetUrls = productConfig.widths.map(w => `${baseUrl}?width=${w} ${w}w`).join(', ');
          const fallbackSrc = `${baseUrl}?width=360`;

          o += `<img class="o-img  o-img--contain  o-ar__item  u-product-bg" src="${fallbackSrc}" srcset="${srcsetUrls}" sizes="${productConfig.sizes}" loading="lazy" alt="" />`;
        }
      }
      (a = a.replace(/{{itemImages}}/g, o)), (a = a.replace(/{{itemAspectRatio}}/g, 'product'));
      const r = [...new Set(t.variants.map(({ compare_at_price: t, price: e }) => t || e))],
        l = Globals.moneyFormat.replace('amount', 'amount_no_decimals');
      if (r.length > 1)
        a = a.replace(
          /{{itemPrices}}/g,
          r.map((t) => Utils.formatMoney(t, l)).join('<span>|</span> ')
        );
      else {
        const e = t.tags.includes('dualsize')
          ? t.tags
              .filter((t) => t.startsWith('variation-'))
              .map((t) => t.replace('variation-', ''))
              .filter((t) => !t.includes('take-it-or-leave-it'))
          : [];
        if (e.length) {
          const i = t.handle + Math.random().toString(36).substring(7);
          (a =
            null != t.compare_at_price_max && t.compare_at_price_max > 0
              ? a.replace(
                  /{{itemPrices}}/g,
                  `<s>${Utils.formatMoney(r[0], l)}</s> ${Utils.formatMoney(t.price_max, l)}<span id="${i}"></span>`
                )
              : a.replace(
                  /{{itemPrices}}/g,
                  `${Utils.formatMoney(r[0], l)}<span id="${i}"></span>`
                )),
            (async () => {
              const t = await Promise.all(
                  e.map((t) =>
                    fetch(`/products/${t}.js`)
                      .then((t) => t.json())
                      .then((t) => t.price / 100)
                  )
                ),
                a = await Promise.all(
                  e.map((t) =>
                    fetch(`/products/${t}.js`)
                      .then((t) => t.json())
                      .then((t) => t.compare_at_price / 100)
                  )
                ),
                o = document.getElementById(i);
              o &&
                (a[0] > 0
                  ? (o.outerHTML = Array.from(
                      new Set(t),
                      (t) =>
                        `<span>|</span><s>${Utils.formatMoney(a[0], l)}</s> ${Utils.formatMoney(t, l)}`
                    ).join(''))
                  : (o.outerHTML = Array.from(
                      new Set(t),
                      (t) => `<span>|</span>${Utils.formatMoney(t, l)}`
                    ).join('')));
            })();
        } else {
          const { price: e, compare_at_price: i } = t.variants[0],
            o = Utils.formatMoney(i || e, l),
            s = Utils.formatMoney(e, l);
          if (1 === t.variants.length) {
            const t = o === s ? s : `<s>${o}</s><span> now</span>${s}`;
            a = a.replace(/{{itemPrices}}/g, t);
          } else
            a =
              o === s
                ? a.replace(
                    /{{itemPrices}}/g,
                    r.map((t) => Utils.formatMoney(t, l)).join('<span>|</span> ')
                  )
                : a.replace(/{{itemPrices}}/g, `<s>${o}</s><span> now</span>${s}`);
        }
      }
      const n = t.tags.find((t) => t.startsWith('badge-'))?.replace('badge-', '');
      a = a.replace(/{{itemBadge}}/g, p(n || ''));
      let c = '',
        d = 'Quick Shop';
      i &&
        ((c = 'disabled'),
        (d = t.tags.find((t) => t.startsWith('coming-soon')) ? 'Coming Soon' : 'Sold Out')),
        (6937455820867 != t.id && 6955798003779 != t.id) || (c = "disabled style='display: none;'"),
        (a = a.replace(/{{quickBuyText}}/g, d)),
        (a = a.replace(/{{quickBuyAttributes}}/g, c)),
        (a = a.replace(/{{extraClass}}/g, '')),
        (a = a.replace(/{{itemAttribute}}/g, '')),
        (a = a.replace(/{{itemId}}/g, t.id)),
        (a = a.replace(/{{itemTitle}}/g, t.title)),
        (a = a.replace(/{{itemHandle}}/g, t.handle)),
        (a = a.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(t)));
      const m = t.metafields.find((t) => 'family_text' === t.key);
      if (m) {
        const t = JSON.parse(JSON.stringify(m.value));
        (itemFamilyHtml = `${t}`), (a = a.replace(/{{itemFamily}}/g, itemFamilyHtml));
      } else a = a.replace(/{{itemFamily}}/g, '');
      const u = t.id,
        g = t.variants,
        h = t.tags,
        f = h.filter((t) => t.startsWith('variation-')).map((t) => t.replace('variation-', ''));
      // Set component attributes once, before any conditional checks
      a = a.replace(/{{quickShopComponentAttributes}}/g, `id="product-card-quick-shop--${u}"`);

      if (h.includes('no-quickshop')) {
        // For products that shouldn't have quick shop (like gift cards), tagged with "no-quickshop"
        (a = a.replace(/{{quickShopVariants}}/g, '')),
          (a = a.replace(
            /<button([^>]*?){{quickShopAttributes}}([^>]*?)>(.*?){{quickShopText}}(.*?)<\/button>/g,
            `<a$1href="${Utils.buildProductItemUrl(t)}"$2>$3{{quickShopText}}$4</a>`
          )),
          (a = a.replace(/{{quickShopText}}/g, 'View Product'));
      }
      else if (f.length <= 0 && g.length <= 1)
        (a = a.replace(/{{quickShopVariants}}/g, '')),
          (a = a.replace(/{{quickShopText}}/g, 'Add to Bag')),
          (a = a.replace(
            /{{quickShopAttributes}}/g,
            `js-add-to-cart data-variant-id="${g[0].id}"`
          ));
      else {
        // Handle both variation tags and actual variants
        (a = a.replace(
          /{{quickShopVariants}}/g,
          `<div class="c-product-card__quick-shop-options">\n                                                <div class="plp-quick-shop-grid" id="plp-quick-shop--${u}"></div>\n                                              </div>`
        )),
        (a = a.replace(/{{quickShopText}}/g, 'Quick Shop')),
        (a = a.replace(/{{quickShopAttributes}}/g, 'js-quick-shop'));
        let t = '',
          e = `class="t-font-size--micro" js-add-to-cart`;

        // Handle actual variants if they exist
        if (g.length > 1) {
          for (const variant of g) {
            t += `<div class="plp-quick-shop-option">\n                        <button ${e} data-variant-id="${variant.id}">${variant.title}</button>\n                      </div>`;
          }
          // Replace the empty quick shop grid with one containing our variant buttons
          a = a.replace(
            `<div class="plp-quick-shop-grid" id="plp-quick-shop--${u}"></div>`,
            `<div class="plp-quick-shop-grid" id="plp-quick-shop--${u}">${t}</div>`
          );
        }
        // Handle variation tags
        else if (f.length > 0) {
          e = `${e} data-variant-id="${g[0].id}"`;
          h.includes('Standard 8.5oz')
            ? (t += `<div class="plp-quick-shop-option">\n                        <button ${e}>Standard 8.5oz</button>\n                      </div>`)
            : h.includes('Magnum 27oz') &&
              (t += `<div class="plp-quick-shop-option">\n                        <button ${e}>Magnum 27oz</button>\n                      </div>`);
          const i = h
            .filter((t) => t.startsWith('variantSize-'))
            .map((t) => t.replace('variantSize-', '').replace(' ML', 'ml'));
          for (const a of i)
            t += `<div class="plp-quick-shop-option">\n                        <button ${e}>${a}</button>\n                      </div>`;
          (async (e, i) => {
            const a = await Promise.all(
              f.map(async (t) => {
                const e = await fetch(`/products/${t}.js`),
                  i = await e.json().catch(() => '');
                if (!i) return '';
                let a = `class="t-font-size--micro" js-add-to-cart data-variant-id="${i.variants[0].id}"`;
                i.available || (a += ' disabled');
                let o = '';
                i.tags.includes('Standard 8.5oz')
                  ? (o += `<div class="plp-quick-shop-option">\n                        <button ${a}>Standard 8.5oz</button>\n                      </div>`)
                  : i.tags.includes('Magnum 27oz') &&
                    (o += `<div class="plp-quick-shop-option">\n                        <button ${a}>Magnum 27oz</button>\n                      </div>`);
                const s = i.tags
                  .filter((t) => t.startsWith('variantSize-'))
                  .map((t) => t.replace('variantSize-', '').replace(' ML', 'ml'));
                for (const t of s)
                  o += `<div class="plp-quick-shop-option">\n                        <button ${a}>${t}</button>\n                      </div>`;
                return o;
              })
            );
            if (a.every((t) => '' === t)) {
              const t = document.getElementById(`product-card-quick-shop--${e}`),
                a = t.querySelector('.c-product-card__quick-shop-btn');
              t.querySelector('.c-product-card__quick-shop-options').remove(),
                (a.textContent = 'Add to Bag'),
                a.removeAttribute('js-quick-shop'),
                a.setAttribute('js-add-to-cart', ''),
                a.setAttribute('data-variant-id', i),
                document.getElementById(`product-card-quick-shop--${e}`).init();
            } else {
              for (const e of a) t += e;
              (document.getElementById(`plp-quick-shop--${e}`).innerHTML = t),
                document.getElementById(`product-card-quick-shop--${e}`).init();
            }
          })(u, g[0].id);
        }
      }
      const y = t.metafields.find((t) => 'intensity' === t.key);
      let v = '';
      if (y) {
        const t = parseInt(JSON.parse(y.value).value.replace('.0', ''));
        v += `<div class="c-product-card__intensity">\n                                <strong class="c-product-card__intensity-label">Scentensity</strong>\n                                <div aria-label="${t}" class="c-product-card__intensity-circle">`;
        for (let e = 1; e <= 5; e++) v += e <= t ? `<i class="filled">${e}</i>` : `<i>${e}</i>`;
        v += '</div></div>';
      }
      return (a = a.replace(/{{itemIntensity}}/g, v)), a;
    }),
    (ProductPaginationDefault.prototype.compileTemplate = function (t) {
      t || (t = this.totalProduct);
      var e = parseInt(Globals.queryParams.page),
        i = Math.ceil(t / Globals.queryParams.limit);
      if (i > 1) {
        var a = boostPFSTemplate.paginateHtml,
          o = e > 1 ? boostPFSTemplate.previousHtml : '';
        (o = o.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', e, e - 1))),
          (a = a.replace(/{{previous}}/g, o));
        var s = e < i ? boostPFSTemplate.nextHtml : '';
        (s = s.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', e, e + 1))),
          (a = a.replace(/{{next}}/g, s));
        for (var r = [], l = e - 1; l > e - 3 && l > 0; l--) r.unshift(l);
        e - 4 > 0 && r.unshift('...'), e - 4 >= 0 && r.unshift(1), r.push(e);
        for (var n = [], c = e + 1; c < e + 3 && c <= i; c++) n.push(c);
        e + 3 < i && n.push('...'), e + 3 <= i && n.push(i);
        for (var p = '', d = r.concat(n), m = 0; m < d.length; m++)
          '...' == d[m]
            ? (p += boostPFSTemplate.pageItemRemainHtml)
            : (p +=
                d[m] == e ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml),
            (p = (p = p.replace(/{{itemTitle}}/g, d[m])).replace(
              /{{itemUrl}}/g,
              Utils.buildToolbarLink('page', e, d[m])
            ));
        return a.replace(/{{pageItems}}/g, p);
      }
      return '';
    }),
    (ProductSorting.prototype.compileTemplate = function () {
      var t = '';
      if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
        var e = Utils.getSortingList();
        if (e) {
          var i = '<option value="" selected>Sort By</option>';
          for (let t in e) i += '<option value="' + t + '">' + e[t] + '</option>';
          t = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, i);
        }
      }
      return t;
    }),
    (ProductList.prototype.afterRender = function (e) {
      e || (e = this.data);
      const i = [],
        a = [];
      const metaSource =
        typeof collectionMeta !== 'undefined' && collectionMeta !== null ? collectionMeta : [];
      const metaList = Array.isArray(metaSource) ? metaSource : Object.values(metaSource);
      for (const t of metaList) t.type ? i.push(t) : a.push(t);
      (window.SwymCallbacks = window.SwymCallbacks || []),
        window.SwymCallbacks.push((t) => {
          const a = [
            ...e.map((t) => {
              const e = t;
              return (e.featured_image = Utils.getFeaturedImage(e.images_info)), e;
            }),
            ...i.map(({ product: t }) => t),
          ].filter(Boolean);
          t.mapShopifyProducts(a),
            a.forEach(({ available: t, id: e, compare_at_price_min: i, price_min: a, tags: o }) => {
              const s = t ? (i > a ? i : a) : boostPFSConfig.label.sold_out,
                r = o.find((t) => t.startsWith('color-')),
                l = r ? p(r.replace('color-', '')).replace('-', ' ') : void 0;
              window.SwymViewProducts[e] = {
                ...window.SwymViewProducts[e],
                pr: `${s}`,
                cprops: { ...(l && { color: l }) },
              };
            }),
            t.initializeActionButtons(Selector.products);
        });
      const { eventType: o } = this;
      'init' === o
        ? ('init' !== this.parent.eventType ||
            window.location.search.includes('sort') ||
            (Globals.queryParams.sort = ''),
          (r = this.totalProduct),
          document.querySelector('.js-filter')?.classList.remove('is-filtered'))
        : this.totalProduct === r
          ? document.querySelector('.js-filter')?.classList.remove('is-filtered')
          : document.querySelector('.js-filter')?.classList.add('is-filtered'),
        '/search' !== window.location.pathname &&
          ('init' === o
            ? ((l =
                'B' === collectionLayout
                  ? r < 4
                    ? 0
                    : r < 8
                      ? 1
                      : r < 12
                        ? 2
                        : 3
                  : r < 8
                    ? 0
                    : r < 16
                      ? 1
                      : r < 28
                        ? 2
                        : r < 36
                          ? 3
                          : 4),
              t({ elContainer: this.$element[0], blocks: i, limit: l }),
              t({ elContainer: this.$element[0], blocks: a, limit: l }),
              (n = !0))
            : this.totalProduct !== r || n
              ? ((n = !1), (c = 1))
              : (t({ elContainer: this.$element[0], blocks: i, limit: l }),
                t({ elContainer: this.$element[0], blocks: a, limit: l }),
                (n = !0)));

      // Wait for Yotpo to load and reinit Yotpo widgets
      const yotpoProductListRoot = this.$element && this.$element[0];
      let checkYotpoCounter = 0;

      function checkForYotpo() {
        checkYotpoCounter++;

        // Don't keep checking endlessly, give up after 10 tries
        if (checkYotpoCounter > 10) {
          clearInterval(window.boostYotpoInterval);
          return;
        }

        const widgetsApi = window.yotpoWidgetsContainer;
        if (!widgetsApi || typeof widgetsApi.initWidgets !== 'function') {
          return;
        }

        // PLP/search cards only use Yotpo 3.0 (.yotpo-widget-instance); re-scan after AJAX.
        // https://support.yotpo.com/docs/loading-yotpo-with-ajax
        const yotpoV3Placeholder = yotpoProductListRoot
          ? yotpoProductListRoot.querySelector('.yotpo-widget-instance')
          : document.querySelector('.yotpo-widget-instance');
        if (yotpoV3Placeholder) {
          widgetsApi.initWidgets();
          clearInterval(window.boostYotpoInterval);
        }
      }

      clearInterval(window.boostYotpoInterval);
      window.boostYotpoInterval = setInterval(checkForYotpo, 500);
    }),
    (FilterResult.prototype.afterRender = function (t) {
      t || (t = this.data);
    });
  const e = FilterOptionItemList.prototype.compileTemplate;
  FilterOptionItemList.prototype.compileTemplate = function () {
    return (this.label = this.label.toLowerCase()), e.call(this);
  };
  const i = InstantSearchResultItemProduct.prototype.compileTemplate;
  InstantSearchResultItemProduct.prototype.compileTemplate = function () {
    return (this.title = this.title.toLowerCase()), i.call(this);
  };
  const a = InstantSearchResultItemCollection.prototype.compileTemplate;
  InstantSearchResultItemCollection.prototype.compileTemplate = function () {
    return this.data.title && (this.data.title = this.data.title.toLowerCase()), a.call(this);
  };
  const o = InstantSearchResultItemPage.prototype.compileTemplate;
  InstantSearchResultItemPage.prototype.compileTemplate = function () {
    return this.data.title && (this.data.title = this.data.title.toLowerCase()), o.call(this);
  };
  const s = FilterMobileButton.prototype.compileTemplate;
  (FilterMobileButton.prototype.compileTemplate = function () {
    return (this.label = 'Filter By'), s.call(this);
  }),
    (FilterTreeStyle2.prototype.renderFilterTreeHeader = function () {
      this.style2ActiveFilterOption
        ? (this.$element.find(this.selector.headerTitle).html(this.style2ActiveFilterOption.label),
          this.$element.find(this.selector.backButton).show())
        : (this.$element.find(this.selector.headerTitle).html('Filter By'),
          this.$element.find(this.selector.backButton).hide()),
        this.mathHeightToolbarHeader();
    });
  let r = 0,
    l = 0,
    n = !location.search.includes('pf_'),
    c = 1;
  function p(t) {
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
})();
